import React from "react";
import styled from "styled-components";
import { Variant } from "../TextProps";
import { LinkStyles } from "./Link.styles";
import { type ILinkProps } from "./Link.types";

const StyledLink = styled.a`
  ${LinkStyles};
`;

export const Link: React.FC<ILinkProps> = ({
  variant = Variant.PRIMARY,
  children,
  href,
  target = "_self",
  onClick = () => null,
  tag = "a",
  textColor,
  ...props
}) => {
  return (
    <StyledLink
      href={href}
      target={target}
      onClick={onClick}
      variant={variant}
      as={tag}
      textColor={textColor}
      {...props}
      data-component={"link"}
    >
      {children}
    </StyledLink>
  );
};

export default Link;
